import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PurchaseRoutingModule } from './purchase-routing.module';
import { InventoryCategoryComponent } from './inventory-category/inventory-category.component';
import { InventoryItemCategoryComponent } from './inventory-item-category/inventory-item-category.component';
import { InventoryItemComponent } from './inventory-item/inventory-item.component';
import { UOMComponent } from './uom/uom.component';
import { StockInformationComponent } from './stock-information/stock-information.component';
import { PurchaseOrderComponent } from './purchase-order/purchase-order.component';
import { StockStatementComponent } from './stock-statement/stock-statement.component';
import { PurchaseOrderReceivingComponent } from './purchase-order-receiving/purchase-order-receiving.component';
import { PurchaseOrderApprovalComponent } from './purchase-order-approval/purchase-order-approval.component';
import { PurchaseInvoiceComponent } from './purchase-invoice/purchase-invoice.component';
import { PurchasePaymentComponent } from './purchase-payment/purchase-payment.component';
import { VendorDueReportComponent } from './vendor-due-report/vendor-due-report.component';
import { GeneralInvoicePaymentComponent } from './general-invoice-payment/general-invoice-payment.component';
import { AdminModule } from '../admin/admin.module';
import { FormsModule } from '@angular/forms';
import { BsDatepickerModule, TimepickerModule, TypeaheadModule } from 'ngx-bootstrap';
import { NgxEditorModule } from 'ngx-editor';
import { PrintPurchaseOrderComponent } from './print-purchase-order/print-purchase-order.component';
import { PrintPOApprovalComponent } from './print-poapproval/print-poapproval.component';
import { StockAdjustmentComponent } from './stock-adjustment/stock-adjustment.component';
import { StockAdjustmentPrintComponent } from './stock-adjustment-print/stock-adjustment-print.component';


@NgModule({
  declarations: [InventoryCategoryComponent, InventoryItemCategoryComponent, InventoryItemComponent, UOMComponent, StockInformationComponent, PurchaseOrderComponent, StockStatementComponent, PurchaseOrderReceivingComponent, PurchaseOrderApprovalComponent, PurchaseInvoiceComponent, PurchasePaymentComponent, VendorDueReportComponent, GeneralInvoicePaymentComponent, PrintPurchaseOrderComponent, PrintPOApprovalComponent, StockAdjustmentComponent, StockAdjustmentPrintComponent],
  imports: [
    CommonModule,
    PurchaseRoutingModule,
    AdminModule,   
    FormsModule,
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    TypeaheadModule.forRoot(),
    NgxEditorModule,
  ]
})
export class PurchaseModule { }
